import { useState, useMemo } from "react";
import moment from "moment";
import {
  sortProjectData,
  sortSubtasks,
  resetProjectData,
} from "../../../../Redux/Reducers/RegistriesReducers/ProjectReducer/index";
import {
  sortCrmData,
  resetCrmData,
} from "../../../../Redux/Reducers/RegistriesReducers/CrmReducer/index";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  IconButton,
  Icon,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import DoubleLine from "./../../../../Components/DoubleLine/DoubleLine";
import "./DetailsTable.scss";
import _ from "lodash";
import { useDispatch } from "react-redux";
const DetailsTable = ({ headers, data, buttons, taskUuid }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
    dispatch(sortCrmData({ keys: [key], isAscending: direction === "asc" }));

    dispatch(
      sortProjectData({ keys: [key], isAscending: direction === "asc" })
    );
    dispatch(
      sortSubtasks({
        taskUuid,
        keys: [key],
        isAscending: direction === "asc",
      })
    );
  };
  const handleReset = () => {
    setSortConfig({ key: null, direction: "asc" }); // Reset lokalnego sortowania
    dispatch(resetProjectData()); // Przywróć dane Redux
    dispatch(resetCrmData());
  };
  const renderCellContent = (value, column) => {
    const date = value ? moment(value).format("DD-MM-YYYY") : "-";
    const time =
      value && column.momentTime ? moment(value).format("HH:mm") : "-";

    if (column.momentDate && column.momentTime) {
      return <DoubleLine firstLine={date} secondLine={time} />;
    } else if (column.momentDate) {
      return date;
    }

    if (column.tooltip) {
      return (
        <Tooltip title={value || ""}>
          <div className="col-no-2 text-lines-clamp">
            <span className="text" style={{ cursor: "pointer" }}>
              {value || "-"}
            </span>
          </div>
        </Tooltip>
      );
    }

    return <span className="text">{value || "-"}</span>;
  };

  return (
    <>
      <div className="d-flex">
        {" "}
        {buttons}
        <Tooltip title={t("global:project.resetProjectTable")}>
          <IconButton
            sx={{
              borderRadius: "1px",
              padding: "1px",
              backgroundColor: "var(--BMX-secondary)",
              "&:hover": {
                backgroundColor: "var(--BMX-secondary)",
                boxShadow: "none",
              },
              marginBottom: "0.8rem",
              marginLeft: "0.2rem",
              maxWidth: "15px",
            }}
            onClick={handleReset}
          >
            <Icon className="white text" style={{ fontSize: "0.95rem" }}>
              restart_alt
            </Icon>
          </IconButton>
        </Tooltip>
      </div>

      <TableContainer
        className="DetailsTable"
        style={{ maxHeight: "36vh", overflowY: "auto" }}
      >
        <Table stickyHeader style={{ tableLayout: "fixed" }}>
          <TableHead>
            <TableRow>
              {headers.map(({ key, name, width, sort }) => (
                <TableCell
                  key={key}
                  className="header-cell"
                  style={{ width, position: "sticky", top: 0, zIndex: 1 }}
                  onClick={() => sort && handleSort(key, sortConfig)}
                >
                  <div className="d-flex align-items-center">
                    <div>
                      <b style={{ lineHeight: "1.29" }}>{name}</b>
                      {sort && (
                        <IconButton
                          className={`SortButton ${
                            sortConfig.key === key ? "selected" : ""
                          }`}
                          size="small"
                        >
                          <Icon
                            style={{
                              fontSize: "12px",
                              transform:
                                sortConfig.key === key &&
                                sortConfig.direction === "asc"
                                  ? "rotate(180deg)"
                                  : "none",
                              transition: "transform 0.2s",
                            }}
                          >
                            arrow_upward
                          </Icon>
                        </IconButton>
                      )}
                    </div>
                  </div>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((row, rowIndex) => (
              <TableRow key={row.id || rowIndex}>
                {headers.map((column) => (
                  <TableCell
                    key={column.key}
                    style={{ width: column.width }}
                    className="body-cell"
                  >
                    {renderCellContent(row[column.key], column)}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default DetailsTable;
